// Utility function to get or generate cart ID
function getCartID() {
    const generateRandomString = () => {
        const length = 30
        const characters = "ABDEFGHIJKLMNOPQR"
        let randomString = ""

        for(let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length)
            randomString += characters.charAt(randomIndex)
        }

        localStorage.setItem("randomString", randomString)
        return randomString
    }

    const existingRandomString = localStorage.getItem("randomString")
    if (!existingRandomString) {
        return generateRandomString()
    }

    return existingRandomString
}

export default getCartID